import React, { useState, useEffect } from 'react'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import moment from 'moment'

const MailFilter = ({ filter, setFilter }) => {

  const [fromFilterInput, setfromFilterInput] = useState('')
  const [toDateInput, setToDateInput] = useState('')
  const [fromDateInput, setFromDateInput] = useState('')
  const [selectedFilterInput, setSelectedFilterInput] = useState('fromFilterSelection')

  const [submitDisable, setSubmitDisable] = useState(true)
  const [exportCSV, setExportCSV] = useState(true)

  const handleSubmit = () => {
    let filterBody
    if (selectedFilterInput == 'fromFilterSelection') {
      filterBody = { filters: { from: fromFilterInput } }
    } else {
      // date range filter selected
      filterBody = {
        filters: {
          dateRange: {
            fromDate: fromDateInput.replace('T', ' '),
            toDate: toDateInput.replace('T', ' ')
          }
        }
      }
    }
    setFilter(filterBody)
  }

  // enable/disable submit based on From filter input
  useEffect(() => {
    if (fromFilterInput.length > 0) {
      setSubmitDisable(false)
    } else {
      setSubmitDisable(true)
    }
  }, [fromFilterInput])

  // disable submit on change of filter type
  useEffect(() => {
    setfromFilterInput('')
    setFromDateInput('')
    setToDateInput('')
  }, [selectedFilterInput])

  // enable/disable based on from and to dates
  useEffect(() => {
    if (fromDateInput != '' && toDateInput != '') {
      let from = moment(fromDateInput)
      let to = moment(toDateInput)
      if (from > to) {
        setSubmitDisable(true)
      } else {
        setSubmitDisable(false)
      }
    } else {
      // while resetting filter
      setSubmitDisable(true)
    }
  }, [fromDateInput, toDateInput])

  return <div className='filter-section'>
    <Row>
      <Col md={2}> <div className='filter-select'>
        <Form.Select value={selectedFilterInput}
          onChange={(e) => {
            setSelectedFilterInput(e.target.value)
            setSubmitDisable(true)
          }}>
          <option value="fromFilterSelection">From</option>
          <option value="dateRangeSelection">Received On</option>
        </Form.Select>
      </div>
      </Col>
      <Col md={7}>
        <div className='filter-inputs'>
          {selectedFilterInput == 'fromFilterSelection' && <>
            <input
              id="from-filter"
              value={fromFilterInput}
              onChange={({ currentTarget }) => {
                setfromFilterInput(currentTarget.value)
              }}
              placeholder='Filter by sender...'
              type='text'
              className="form-control" />
          </>}
          {selectedFilterInput == 'dateRangeSelection' && <>
            <label htmlFor="start-date">From: </label>
            <input
              value={fromDateInput}
              id="start-date"
              type='datetime-local'
              step={2}
              onChange={({ currentTarget }) => {
                if (currentTarget.value) {
                  let splitArr = currentTarget.value.split('T')
                  if (splitArr[1] && splitArr[1].split(':').length == 2) {
                    setFromDateInput(currentTarget.value + ':00')
                  } else {
                    setFromDateInput(currentTarget.value)
                  }
                }
              }}
              className="form-control" />
            <label htmlFor="end-date">To: </label>
            <input
              id="end-date"
              type='datetime-local'
              onChange={({ currentTarget }) => {
                if (currentTarget.value) {
                  let splitArr = currentTarget.value.split('T')
                  if (splitArr[1] && splitArr[1].split(':').length == 2) {
                    setToDateInput(currentTarget.value + ':00')
                  } else {
                    setToDateInput(currentTarget.value)
                  }
                }
              }}
              value={toDateInput}
              step={2}
              className="form-control" />
          </>}
        </div>
      </Col>
      <Col md={3}>
        <button
          className={!submitDisable ? 'primary-btn search-btn' : 'disabled-btn-filter'}
          disabled={submitDisable}
          onClick={handleSubmit}
        >Submit</button>

        <a href=''
          className='reset-filter'
          onClick={(e) => {
            e.preventDefault()
            setfromFilterInput('')
            setFromDateInput('')
            setToDateInput('')
            if (filter && filter.filters) {
              setFilter({})
            }
          }}>Reset</a>
      </Col>
    </Row>
  </div>
}

export default MailFilter